import React, { useRef } from 'react'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import MaterialTable, { MTableToolbar } from '@material-table/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import { isEmailValid } from 'src/utils/inputValidations'
import { IoIosArrowForward } from 'react-icons/io'

const PartnersPage = (props) => {
  const { partners, updatePartners, generateQuiz } = props

  const URL_BASE =
    process.env.NODE_ENV === 'development'
      ? 'https://gvctest.lucia.com.co/home/partner_quiz?'
      : 'https://gvc.lucia.com.co/home/partner_quiz?'

  const URL_BASE2 =
    process.env.NODE_ENV === 'development'
      ? 'https://gvctest.lucia.com.co/home/follow?'
      : 'https://gvc.lucia.com.co/home/follow?'

  const renderStatus = (url) => ({
    4: { fn: <p style={{ fontSize: '16px' }}>Consolidado</p>, disabled: false },
    3: {
      fn: (
        <Button
          color="consolidation"
          round
          fullWidth
          onClick={() => window.open(url, '_blank')}
        >
          Conciliar
          <IoIosArrowForward />
        </Button>
      ),
      disabled: true,
    },
    2: {
      fn: (
        <Button
          color="evaluation"
          round
          fullWidth
          onClick={() => window.open(url, '_blank')}
        >
          Evaluar socio
          <IoIosArrowForward />
        </Button>
      ),
      disabled: true,
    },
    1: {
      fn: <p style={{ fontSize: '16px' }}>Pend evaluación socio </p>,
      disabled: true,
    },
    0: {
      fn: <p style={{ fontSize: '16px' }}> Sin evaluación </p>,
      disabled: false,
    },
  })

  function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str))
  }

  const stateRender = (state) => {
    const url = new URL(URL_BASE)
    const urlParam =
      state.estado === '3'
        ? {
            tipo: 'conciliacion',
            idEncuestaJefe: state.idEncJefe,
            idEncuestaSocio: state.idEncSocio,
            idSocio: state.id,
          }
        : {
            tipo: 'jefe',
            idSocio: state.id,
            idEncuestaSocio: state.idEncSocio,
          }

    url.searchParams.append('t', b64EncodeUnicode(JSON.stringify(urlParam)))

    return renderStatus(url)[Number(state.estado)].fn
  }

  const renderTrack = (state) => {
    const url = new URL(URL_BASE2)

    const urlParam = {
      tipo: 'jefe',
      idSocio: state.id,
      idEncuestaSocio: state.idEncSocio,
    }

    url.searchParams.append('t', b64EncodeUnicode(JSON.stringify(urlParam)))

    const statusEvaluation = {
      fn: (
        <Button
          color="tasks"
          fullWidth
          onClick={() => window.open(url, '_blank')}
        >
          Acciones
        </Button>
      ),
    }

    return state.idEncSocio && state.id ? (
      statusEvaluation.fn
    ) : (
      <p style={{ fontSize: '16px' }}> No hay tareas aún</p>
    )
  }

  const renderTotalTasks = (partner) =>
    `${partner.tareasPendientes}  /  ${partner.tareasVencidas}  /  ${partner.tareasPorVencer}  / ${partner.tareasTotales}`

  const checkboxRef = useRef([])

  const columns = [
    {
      title: 'Socio',
      field: 'razonSocial',
      editable: 'never',
      cellStyle: {
        color: '#2699FB',
      },
    },
    { title: 'Jefe', field: 'jefe', editable: 'never' },
    {
      title: 'Acciones: pendientes / vencidas / a tiempo / totales',
      field: 'tareas',
      editable: 'never',
      render: (rowData) => renderTotalTasks(rowData),
      headerStyle: {
        background: '#F6F6F6',
      },
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      title: 'Última modificación',
      field: 'ultimaModificacion',
      editable: 'never',
    },
    {
      title: 'Estado',
      field: 'estado',
      editable: 'never',
      render: (rowData) => stateRender(rowData),
    },
    {
      title: 'Seguimiento',
      field: 'seguimiento',
      editable: 'never',
      render: (rowData) => renderTrack(rowData),
      headerStyle: {
        background: '#F6F6F6',
      },
    },
    {
      title: 'Correo',
      field: 'correo',
      type: 'string',
      validate: (rowData) =>
        isEmailValid(rowData.correo)
          ? true
          : { isValid: false, helperText: 'Correo invalido' },
    },
  ]

  return (
    <div>
      <CardTitle title="Listado de socios comerciales" />
      <MaterialTable
        style={{
          color: '#5A5A5A',
          fontWeight: 600,
        }}
        title="Solicitudes"
        columns={columns}
        data={partners}
        components={{
          Toolbar: (prop) => (
            <div
              style={{
                background: '#FCFCFC',
                color: '#E2A233',
              }}
            >
              <MTableToolbar {...prop} />
            </div>
          ),
        }}
        editable={{
          onRowUpdate: (newData) =>
            new Promise((resolve) => {
              updatePartners({
                newData,
              })
              resolve()
            }),
        }}
        options={{
          showSelectAllCheckbox: false,
          selection: true,
          selectionProps: (rowData) => ({
            disabled: renderStatus()[rowData.estado].disabled,
            color: 'primary',
          }),
          headerStyle: {
            backgroundColor: '#F6F6F6',
            color: '#161615',
            fontSize: '14px',
            fontWeight: 700,
            textAlign: 'center',
          },
          actionsColumnIndex: -1,
        }}
        onSelectionChange={(items) => {
          checkboxRef.current = items
        }}
        localization={{
          toolbar: {
            addRemoveColumns: 'Agregar o eliminar columnas',
            exportAriaLabel: 'Exportar',
            exportName: 'Exportar a CSV',
            exportTitle: 'Exportar',
            nRowsSelected: '{0} filas seleccionadas',
            searchPlaceholder: 'Buscar',
            searchTooltip: 'Buscar',
            showColumnsAriaLabel: 'Mostrar columnas',
            showColumnsTitle: 'Mostrar columnas',
          },
        }}
        actions={[
          {
            tooltip: 'Generar encuesta',
            icon: () => (
              <Button
                color="warning"
              >
                Generar Encuesta
              </Button>
            ),
            onClick: () => generateQuiz(checkboxRef.current)
          },
        ]}
      />
    </div>
  )
}

export default PartnersPage
